import React, { ReactNode } from 'react';
import Button from '../Button';

export interface DrawerFooterProps {
    isConnected: boolean
    isLoading: boolean
    onConnect?: () => Promise<void>
    onDisconnect?: () => Promise<void>
    customActions?: ReactNode
    isDisable?:boolean
    type?:string
  }

const DrawerFooter: React.FC<DrawerFooterProps> = ({
  isConnected,
  isLoading,
  onConnect,
  onDisconnect,
  customActions,
  isDisable,
  type
}) => {
  return (
    <div
      className="offcanvas-footer d-flex justify-content-end border-top py-4 px-8"
      style={{ position: "sticky", bottom: 0, backgroundColor: "white", zIndex: 5 }}
    >
        <>
        {type === 'cookie' ? (
            <div className="d-flex gap-3">
              <Button
                onClick={onConnect}
                disabled={isDisable || isLoading}
                btnType='primary'
              >
                {isLoading ? (
                  <>
                    Saving...
                    <span className="spinner-border spinner-border-sm align-middle"></span>
                  </>
                ) : (
                  'Save'
                )}
              </Button>
            </div>
          ) : (
          !isConnected ? (
            <>
              {isLoading ? (
                <button
                  type="submit"
                  className="btn btn-sm fs-6"
                  style={{ backgroundColor: "#0E9F6E", color: "#FFFFFF", height: "40px" }}
                  disabled
                >
                  Connecting...
                  <span className="spinner-border spinner-border-sm align-middle m-2"></span>
                </button>
              ) : (
                <button
                  type="submit"
                  className="btn btn-sm fs-6"
                  onClick={onConnect}
                  disabled={isDisable}
                  style={{ backgroundColor: "#0E9F6E", color: "#FFFFFF", height: "40px" }}
                  onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#148363")}
                  onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#0E9F6E")}
                >
                  Connect
                </button>
              )}
            </>
          ) : (
            <>
              {isLoading ? (
                <button
                  type="button"
                  className="btn btn-sm fs-6"
                  style={{ background: "#FDEAEC", color: "#EE3043", height: "40px" }}
                  disabled
                >
                  Disconnecting...
                  <span className="spinner-border spinner-border-sm align-middle m-2"></span>
                </button>
              ) : (
                <button
                  type="button"
                  className="btn btn-sm fs-6"
                  onClick={onDisconnect}
                  style={{ background: "#FDEAEC", color: "#EE3043", height: "40px" }}
                  onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#F9D5D9")}
                  onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#FDEAEC")}
                >
                  Disconnect
                </button>
              )}
            </>
          ))}
        </>
      
    </div>
  );
};

export default DrawerFooter;